/*
*  axios分为两种，一种是公用，在没有登陆之前cookie中没有pssid，不需要判断登陆情况，使用情况较少
*  另一种为登陆之后，需要判断pssid时效等状态
* */
// 需要判断pssid
import axios from 'axios'
import qs from 'qs'
import environment from './environment'
import { encrypt } from '@/page/cw/tools'
import Cookies from 'js-cookie'
import vue from '../main'
import { Notification, Message } from 'element-ui';

export const cw1 = environment.cw1Url
export const api5 = environment.api5Url
export const api3 = environment.api3Url
export const pcapi = environment.pcUrl

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded' // 跨域
axios.defaults.withCredentials = true

let axiosLogined = axios.create()
let axiosBeforeLogin = axios.create()

// 拦截器 需要判断pssid的
axiosLogined.interceptors.request.use((config) => {
    // 在发送请求之前做些什么
    if (!Cookies.get('PSSID')) {
        // 删除cookie中的pssid
        Cookies.remove('PSSID')
        // 清空vuex中的路由和用户信息
        vue.$store.commit('clearRoutes')
        vue.$store.commit('clearCwUserInfo')
        window.location.href = '/user/login'
    }
    return config;
}, (error) => {
    // 对请求错误做些什么
    console.log(error)
    return Promise.reject(error)
})

// response响应器  主要处理 尚未登陆请求
axiosLogined.interceptors.response.use((response) => {
    if ((response.data.success === false && response.data.code === 100007) || (response.data.success === false && response.data.msg === "尚未登录")) {
        // 删除cookie中的pssid
        Cookies.remove('PSSID')
        // 清空vuex中的路由和用户信息
        vue.$store.commit('clearRoutes')
        vue.$store.commit('clearCwUserInfo')
        window.location.href = '/user/login'
    }
    if(!response.data.success) {
        //100002) 新版本证书 ssl证书不存在详情接口返回的code
        if(response.data.code !== 100009) {
           Message.error(response.data.msg);
        }
        return Promise.reject(response.data)
    }
    if ((response.data.success && response.data.code === 100008)) {
        Notification({
            title: '错误',
            message: response.data.msg,
            type: 'error'
        });
        return false
    }
    return response
}, (error) => {
    // 对请求错误做些什么
    console.log(error)
    return Promise.reject(error)
})


const fetchIe9 = (url, options = {}) => {
    if (window.XDomainRequest) {
        return new Promise((resolve, reject) => {
            const method = options.method || 'POST'
            const timeout = options.timeout || 30000
            let data = options || {}
            if (data instanceof Object) {
                data = JSON.stringify(data)
            }
            const XDR = new XDomainRequest()
            XDR.open(method, url)
            XDR.timeout = timeout
            XDR.onload = () => {
                try {
                    const json = JSON.parse(XDR.responseText)
                    return resolve(json)
                } catch (e) {
                    reject(e)
                }
                return reject(new Error('error'))
            }
            // fix random aborting: https://cypressnorth.com/programming/internet-explorer-aborting-ajax-requests-fixed/
            XDR.onprogress = () => { }
            XDR.ontimeout = () => reject(new Error('XDomainRequest timeout'))
            XDR.onerror = () => reject(new Error('XDomainRequest error'))
            setTimeout(() => {
                XDR.send(data)
            }, 0)
        })
    } else {
        // native fetch or polyfill fetch(XMLHttpRequest)
        // fetch...
    }
}
// get和post
const postFetch = (params, url) => {
    if (!ifIe9()) {
        return axiosLogined.post(`${api3 + url}`, params).then(res => res.data)
    } else {
        return fetchIe9(`${api3 + url}?${params}`)
    }
}
const getFetch = (url) => {
    if (!ifIe9()) {
        return axiosLogined.get(`${api3 + url}`).then(res => res.data)
    } else {
        return fetchIe9(`${api3 + url}`)
    }
}
const postFetchCom = (params, url) => {
    if (!ifIe9()) {
        return axiosBeforeLogin.post(`${api3 + url}`, params).then(res => res.data)
    } else {
        return fetchIe9(`${api3 + url}?${params}`)
    }
}
const getFetchCom = (url) => {
    if (!ifIe9()) {
        return axiosBeforeLogin.get(`${api3 + url}`).then(res => res.data)
    } else {
        return fetchIe9(`${api3 + url}`)
    }

}

// 判断是不是ie9
function ifIe9() {
    return navigator.appName === 'Microsoft Internet Explorer' && parseInt(navigator.appVersion.split(';')[1].replace(/[ ]/g, '').replace('MSIE', '')) <= 9
}
// 部分接口加密 （code = 100009）
function setParams(params) {
    console.log(params)
    return {
        code: environment.apiCode,
        param: encrypt(JSON.stringify(params), environment.apiCode, environment.apiKey)
    }
}

// 获取token接口
export const getToken = () => { return getFetchCom('/AccessToken/index?' + 'code=' + environment.apiCode) }



// 登陆接口
export const login = params => {
    return postFetchCom(qs.stringify(setParams(params)), `/qxy/cwUser/login`)
}

// 检查登陆状态
export const getUserInfo = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/cwUser/getUserInfo`)
}

// 登出接口
export const logout = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/cwUser/logout`)
}

// 获取服务信息接口
export const getServiceInfo = params => {
    return getFetch(`/qxy/cwUser/getServiceInfo?` + qs.stringify(setParams(params)))
}

// 获取网站信息接口
export const getWebInfo = params => {
    return getFetch(`/qxy/cwUser/getWebInfo?` + qs.stringify(setParams(params)))
}

// 获取网站信息接口
export const setWebInfo = params => {
    return getFetch(`/qxy/cwUser/setWebInfo?` + qs.stringify(setParams(params)))
}

// 信用官网入口
export const getEntranceSearch = params => {
    return getFetch(`/qxy/cwUser/entranceSearch?` + qs.stringify(setParams(params)))
}

// 网站体检入口
export const getWebCheck = params => {
    return getFetch(`/qxy/cwUser/getWebCheck?` + qs.stringify(setParams(params)))
}

// 账号设置 - 修改密码
export const setPassword = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/cwUser/setPassword`)
}

// 账号设置 - 修改手机
export const setNoticePhone = params => {
    return getFetch(`/qxy/cwUser/setNoticePhone?` + qs.stringify(setParams(params)))
}

// 账号设置 - 修改邮箱
export const setNoticeEmail = params => {
    return getFetch(`/qxy/cwUser/setNoticeEmail?` + qs.stringify(setParams(params)))

}

// 通栏信息获取接口
export const getBannerInfo = params => {
    return getFetch(`/qxy/cwUser/getBannerInfo?` + qs.stringify(setParams(params)))
}

// 通栏信息设置接口
export const setBannerInfo = params => {
    return getFetch(`/qxy/cwUser/setBannerInfo?` + qs.stringify(setParams(params)))
}

// 获取官网防护嵌套页地址
export const getDefendUrl = params => {
    return getFetch(`/api/domain/list?` + qs.stringify(params))
}

// 短信发送接口
export const sendSmsCode = params => {
    let a = {
        code: environment.apiCode,
        sign: environment.sign
    }
    return getFetchCom(`/qxy/tools/sendSmsCode?` + qs.stringify(a) + `&param={"phone":"${params.phone}","id":"${params.id}"}`)
}

// TODO 短信发送接口2
export const sendSmsCode2 = params => {
    // let a = {
    //     code: environment.apiCode,
    //     sign: environment.sign
    // }
    // return postFetchCom(`/utensil/SendSmsCode?` + qs.stringify(a) + `&param={"phone":"${params.phone}","id":"${params.id}"}`)
    return postFetchCom(qs.stringify(setParams(params)), `/qxy/utensil/SendSmsCode`)
}

// 忘记密码找回接口
export const findPassword = params => {
    return postFetchCom(qs.stringify(setParams(params)), `/qxy/cwUser/findPassword`)
}

// 纳网云备份信息获取接口
export const websiteBackup = params => {
    return getFetch(`/qxy/cwUser/websiteBackup?` + qs.stringify(setParams(params)))
}

// 小程序信息获取接口
export const getMiniProgram = params => {
    return getFetch(`/qxy/cwUser/getMiniProgram?` + qs.stringify(setParams(params)))
}

// 纳网云登陆接口
export const ebeimWebsiteLogin = params => {
    return axios({
        url: params.url,
        method: 'post',
        data: { userName: params.username, password: params.password },
        transformRequest: [function (data) {
            data = qs.stringify(data)
            return data
        }],
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
}

// 纳网云安全登录接口 (请注意：这个不是接口 返回的是个url字符串，用来直接插到iframe上)
export const websiteDefend = params => {
    return `${api3}/qxy/cwUser/WebsiteDefend?` + qs.stringify(setParams(params))
}

// 账号设置 - 验证邮箱
// export const sendSmsCodeEmail = params => {
//     return getToken().then(
//         res => {
//             let a = {
//                 code: environment.apiCode,
//                 sign: environment.sign
//             }
//             return getFetchCom(`/tools/sendSmsCodeEmail?` + qs.stringify(a) + `&param={"email":"${params.email}","id":"${params.id}"}`)
//         }
//     )
// }

// TODO 账号设置 - 验证邮箱
export const sendSmsCodeEmail2 = params => {

    // let a = {
    //     code: environment.apiCode,
    //     sign: environment.sign
    // }
    // return getFetchCom(`/tools/sendSmsCodeEmail?` + qs.stringify(a) + `&param={"email":"${params.email}","id":"${params.id}"}`)
    return postFetch(qs.stringify(setParams(params)), `/qxy/utensil/SendEmsCode`)
}

// 获取概要接口
export const getSimpleReport = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/creditReport/getSimpleReport`)
}

// 确认创建任务接口
export const taskCreateSure = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/creditReport/taskCreateSure`)
}

// 创建任务接口
export const taskCreate = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/creditReport/taskCreate`)
}

// 升级邮件通知接口
export const versionUpgrade = params => {
    return getFetch(`/qxy/cwUser/versionUpgrade?` + qs.stringify(setParams(params,)))
}

// TODO
// 获取信用官网推广位数据
export const getAdvertisingSpace = params => {
    return getFetch(`/qxy/cwUser/GetAdvertisingSpace?` + qs.stringify(setParams(params)))
}

// 设置提交推广位
export const setAdvertisingSpace = params => {
    return getFetch(`/qxy/cwUser/SetAdvertisingSpace?` + qs.stringify(setParams(params)))
}

// 广告位（推广位）审核单撤回
export const withdrawAS = params => {
    return getFetch(`/qxy/cwUser/WithdrawAS?` + qs.stringify(setParams(params)))
}

// 推广位关闭
export const closeAS = params => {
    return getFetch(`/qxy/cwUser/CloseAS?` + qs.stringify(setParams(params)))
}


// 公信中国平台是否显示状态变更接口
export const changeGxIsShow = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/cwUser/changeGxIsShow`)
}

// 企业简介信息获取
export const companyInfo = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/companyInfo`)
}
// 更新企业信息
export const UpdateCompanyInfo = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/UpdateCompanyInfo`)
}


// 主营业务列表获取
export const GetMainBusinessList = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/GetMainBusinessList`)
}

//主营业务单个获取
export const GetMainBusiness = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/GetMainBusiness`)
}
//主营业务添加
export const addMainBusiness = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/addMainBusiness`)
}
//主营业务更新
export const updateMainBusiness = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/updateMainBusiness`)
}
//主营业务删除
export const delMainBusiness = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/delMainBusiness`)
}

// 企业荣誉列表获取
export const GetHonorList = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/GetHonorList`)
}
//企业荣誉添加
export const addHonor = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/addHonor`)
}
//企业荣誉单个获取
export const GetHonor = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/GetHonor`)
}
//企业荣誉更新
export const updateHonor = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/updateHonor`)
}
//企业荣誉删除
export const delHonor = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/delHonor`)
}

//企业专利证书添加
export const addPatentCertificate = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/addPatentCertificate`)
}
// 企业专利证书列表获取
export const GetPatentCertificateList = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/GetPatentCertificateList`)
}
// 企业专利证书单个获取
export const GetPatentCertificate = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/GetPatentCertificate`)

}
// 企业专利证书更新
export const updatePatentCertificate = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/updatePatentCertificate`)
}
// 企业专利证书删除
export const delPatentCertificate = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/delPatentCertificate`)
}

//客户案例列表获取
export const GetCaseList = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/GetCaseList`)
}

//客户案例单个获取
export const GetCase = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/GetCase`)
}

//客户案例更新
export const updateCase = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/updateCase`)

}

//客户案例添加
export const addCase = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/addCase`)
}

//客户案例删除
export const delCase = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/delCase`)
}

//企业媒体添加
export const addMedia = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/addMedia`)
}
//企业媒体删除
export const delMedia = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/delMedia`)
}
//企业媒体列表获取
export const GetMediaList = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/GetMediaList`)
}
//企业媒体单个获取
export const GetMedia = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/GetMedia`)
}
//企业媒体更新
export const updateMedia = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/CwCompany/updateMedia`)
}
// 获取SSL当前进度
export const SSLStepInfo = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/QxySsl/StepInfo`)
}
// ssl申请

export const SSLApply = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/QxySsl/Apply`)
}

// dns验证
export const SSLCheck = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/QxySsl/Check`)
}
// ssl重新申请证书，证书重置
export const SSLReApply = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/QxySsl/ReApply`)
}
// ssl证书下载
export const SSLDown = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/QxySsl/Down`)
}

// 获取用户后台接入流程
export const processInfo = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/processInfo`)
}

// 主域名正式接入
export const createDomain = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/create`)
}
// 子域名添加
export const subdomainAdd = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/subdomainAdd`)
}
// 子域名列表
export const subdomainList = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/subdomainList`)
}

// 子域名删除
export const subdomainDelete = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/subdomainDelete`)
}

// 确认子域名到下一个节点（2）
export const subdomainStep = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/subdomainStep`)
}

// 返回上一个节点
export const backStep = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/backStep`)
}

// 子域名修改
export const subdomainUpdate = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/subdomainUpdate`)
}

// 确认 dns到下一个节点 （3）
export const activeStep = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/activeStep`)
}

// SSL列表
export const sslList = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/sslList`)
}
// SSL删除
export const sslDelete = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/sslDelete`)
}

// SSL删除
export const sslCreate = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/sslCreate`)
}

// SSL下载
export const sslDown = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/sslDown`)
}


// SSL部署（取消部署）
export const sslDeploy = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/sslDeploy`)
}

// 清理CDN缓存
export const wafClearCache = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/wafClearCache`)
}

// waf所有的设置详情
export const wafInfo = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/wafInfo`)
}

// waf设置.是否开启（防火墙）
export const wafSettings = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/wafSettings`)
}

// 浏览器检查
export const wafBrowserCheck = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/wafBrowserCheck`)
}


// 防盗链设置
export const wafHotlinkProtection = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/wafHotlinkProtection`)
}

// 设置DDOS云防御
export const wafDdos = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/wafDdos`)
}
// 设置CC防护
export const wafSecurityLevel = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/wafSecurityLevel`)
}

// 聚合统计
export const summarycount = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/summarycount`)
}

// 单域名计数曲线型
export const multicount = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/multicount`)
}

// 统计排名型
export const grouptop = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/grouptop`)
}

// 获取详细列表型
export const reportsDetail = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/yjs/reportsDetail`)
}
// 网站检测-域名信息检测
export const checkDomain = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/WebSiteCheck/CheckDomain`)
}

// 网站检测-域名注册&DNS解析检测
export const domainDns = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/WebSiteCheck/DomainDns`)
}

// 网站检测-网站检测
export const webCheck = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/WebSiteCheck/WebCheck`)
}

// 网站检测-安全检测
export const safeCheck = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/WebSiteCheck/SafeCheck`)
}


// 网站检测-SEO检测
export const seoCheck = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/WebSiteCheck/SeoCheck`)
}


// 网站检测优化项
export const toHeaderk = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/WebSiteCheck/ToHeader`)
}


// 新版证书申请
export const newSSLApply = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/QxyRacentSsl/Place`)
}


// SSL证书头部域名列表
export const qxyRacentSsl = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/QxyRacentSsl/index`)
}

// SSL证书头部域名列表
export const certificateInfo = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/QxyRacentSsl/CertificateInfo`)
}


// SSL证书下载
export const qxyRacentSslDownload = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/QxyRacentSsl/Download`)
}


// SSL证书触发验证接口
export const qxyRacentSslVerify = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/QxyRacentSsl/Verify`)
}


// SSL到期更新
export const newSSLReApply = params => {
    return postFetch(qs.stringify(setParams(params)), `/qxy/QxyRacentSsl/RenewalSsl`)
}




// WEBPACK FOOTER //
// ./src/page/cw/req/cwApi.js